import React from 'react';
import { ReactComponent as Arrow } from '../../../../picture/arrow.svg'
import formattedAmount from '../../seller/components/utils';
import { parsedHTML } from './utils';
import { useTranslation } from 'react-i18next';
import RateStatus from './rateStatus';
import Button from '../../../jo-components/ui/button/button';
import Counter from '../../../jo-components/ui/counter/counter';
import './style/rateCard.css';


function RateCounter({rate, setTicketsToBuy, setSelectedRates, ticketsToBuy, selectedRates, disable_plus, goToWaitingList, waiting_list_cta, soldout_label}) {
    const { t } = useTranslation();

    const onChangeTicketsNumber = React.useCallback(( e, value ) => {
        setTicketsToBuy(parseInt(value) || 0)
        setSelectedRates({
            ...selectedRates, [rate.id]: {
                "quantity": parseInt(value) || 0,
                "price": rate.price * (value)
            }
        });
    }, [rate, selectedRates]);

    return (
        <div className='wz-rate-right-container'>
            {rate.display_waiting_list && <Button className='neo-waiting-list-cta' type='primary' label={waiting_list_cta} onClick={goToWaitingList}/>}
            {Boolean(!rate.display_waiting_list && !rate.quantity_available) && <div className='neo-unavailable-rate'>{soldout_label}</div>}
            {Boolean(rate.quantity_available > 0 && !rate.display_waiting_list) && (
                <Counter
                    value={ticketsToBuy}
                    onChange={onChangeTicketsNumber}
                    disabledPlus={disable_plus}
                    max={rate.quantity_available}
                    ariaLabelPlus={t('widget.counter.button-plus', {rate: rate.name})}
                    ariaLabelMinus={t('widget.counter.button-minus', {rate: rate.name})}
                    ariaLabelInput={t('widget.counter.input', {rate: rate.name})}
                    ariaLabelAnnouncer={t('widget.counter.selected_quantity', {count: ticketsToBuy, rate: rate.name})}
                />
            )}
        </div>
    )
}

export default function RateCard({ event, rate, setSelectedRates, selectedRates, disable_plus, onSubmit, waiting_list_cta, soldout_label }) {
    const { t } = useTranslation();
    const { name, description, quantity_available, max_price, min_price } = rate;
    const [showMore, setShowMore] = React.useState(false);
    const [ticketsToBuy, setTicketsToBuy] = React.useState(0);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    const goToWaitingList = React.useCallback(() => {
        onSubmit({ data: { action: 'waiting_list_ticket_step' } });
    }, [onSubmit]);

    const hasDescription = React.useMemo(() => {
        return Boolean(rate.description);
    }, [rate]);

    return (
        <div className={`wz-rate-card-content ${ticketsToBuy ? 'wz-rate-card-content-active' : ''}`}>
            <div className='wz-rate-card-container'>
                <div className='wz-rate-left-container'>
                    <div className='wz-rate-title-and-status'>
                        <div className='wz-rate-title'>{name}</div>
                        {/* TODO - add status when it's ready, not for V1 */}
                        {false && <RateStatus event={event} rate={rate} />}
                    </div>
                    <div className='wz-rate-card'>
                        <div>
                            {event.settings.aff_quantite && <div className='wz-rate-quota'>{t('widget.resale.tickets.available-quantity')} {quantity_available}</div>}
                            {max_price > 0 && (
                                <div className="wz-rate-price">
                                    {t('widget.resale.event.from')} {formattedAmount(min_price, event.currency)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <RateCounter 
                    rate={rate}
                    setTicketsToBuy={setTicketsToBuy}
                    setSelectedRates={setSelectedRates}
                    ticketsToBuy={ticketsToBuy}
                    selectedRates={selectedRates}
                    disable_plus={disable_plus}
                    goToWaitingList={goToWaitingList}
                    waiting_list_cta={waiting_list_cta}
                    soldout_label={soldout_label}
                />
            </div>
            {hasDescription && (
                <>
                    <div className='wz-rate-read-more'>
                        <div className='wz-read-more-container' onClick={toggleShowMore}>
                            <div className='wz-rate-read-more'>{showMore ? t('widget.resale.event.show-less') : t('widget.resale.event.show-more')}</div>
                            <Arrow className={`wz-rate-arrow-icon ${showMore ? 'wz-rate-arrow-icon-down' : 'wz-rate-arrow-icon-up'}`} />
                        </div>
                    </div>
                    <div className={showMore && 'wz-rate-descrption'}>
                        {showMore && parsedHTML(description)}
                    </div>
                </>
            )}
        </div>
    )
}